/* eslint-disable react/prop-types */
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import DatePicker from '../common/DatePicker'
import moment from 'moment'
import ReactTable from 'react-table'
import createTable from 'react-table-hoc-fixed-columns'
// import "react-table/react-table.css";

import CSVExportModal from './CSVExportModal'
import profile_avatar from '../../assets/images/mock/StockProfilePic.png'

const ReactTableFixedColumns = createTable(ReactTable)

const buildHeaders = t => [
  { label: t('common.field.firstName'), key: 'firstname' },
  { label: t('common.field.lastName'), key: 'lastname' },
  { label: t('common.field.date'), key: 'date' },
  { label: t('reports.communityPracticeTable.duration'), key: 'duration' },
  { label: t('common.golf.putting'), key: 'putting' },
  { label: t('common.golf.chipping'), key: 'chipping' },
  { label: t('reports.communityPracticeTable.pitchShots'), key: 'pitchshots' },
  { label: t('reports.communityPracticeTable.wedges'), key: 'wedges' },
  { label: t('common.golf.fullSwingIrons'), key: 'irons' },
  { label: t('common.golf.fullSwingWoods'), key: 'woods' },
  { label: t('common.golf.onCoursePlaySimulation'), key: 'oncourse' },
  { label: t('common.golf.bunkers'), key: 'bunkers' },
]

class CommunityPracticeTable extends Component {
  constructor(props) {
    super(props)

    this.state = {
      showModal: false,
      dataLoader: false,
      data: [],
    }
  }
  toggleModal = () => {
    this.setState({
      showModal: !this.state.showModal,
    })
  }
  createData = () => {
    const { data } = this.props
    const practices = data[0].practices
    const tempData = []
    this.setState({ dataLoader: true })
    if (practices.length > 0) {
      practices.map(practice => {
        const firstname = practice.user.first_name
        const lastname = practice.user.last_name
        const date = practice.activity_date
        const sessions = this.combineSessions(practice)

        tempData.push({
          firstname,
          lastname,
          date: moment(date).format('MM-DD-YYYY'),
          duration: this.calculateDuration(sessions),
          putting: this.calculateSessionDuration(sessions, 1),
          chipping: this.calculateSessionDuration(sessions, 2),
          pitchshots: this.calculateSessionDuration(sessions, 3),
          wedges: this.calculateSessionDuration(sessions, 4),
          irons: this.calculateSessionDuration(sessions, 5),
          woods: this.calculateSessionDuration(sessions, 6),
          oncourse: this.calculateSessionDuration(sessions, 7),
          bunkers: this.calculateSessionDuration(sessions, 8),
        })
      })
    }

    this.setState({ data: tempData }, () => this.toggleModal())
  }
  renderUserAvatarCell = props => (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
    <div
      className='number'
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
      }}
      key={props.value ? props.value.id : null}
      onClick={() =>
        this.props.toProfile(props.value ? props.value.id : null)
      }
    >
      <div className='small-round-image-wrapper'>
        {props.value ? (
          <img
            className='round-image'
            src={
              props.value.avatar
                ? props.value.avatar.file_url
                : profile_avatar
            }
            alt={
              props.value
                ? `${props.value.first_name} ${props.value.last_name}`
                : ''
            }
          />
        ) : null}
      </div>
    </div>
  )
  renderDataSessions = practice_sessions =>
    practice_sessions.reduce(
      (acc, curr) => `${acc} ${curr.practice_type.name},`,
      ''
    )
  renderSessions = ({ value: { practice_sessions } }) =>
    practice_sessions.reduce(
      (acc, curr) => `${acc} ${curr.practice_type.name},`,
      ''
    )
  renderPracticeSessionCell = props => (
    <div
      className='number'
      style={{
        backgroundColor: '',
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <div style={{ color: '#2b3843' }}>{this.renderSessions(props)}</div>
    </div>
  )

  calculateDuration = props => {
    let duration = 0

    props.practice_sessions.map(session => {
      duration += session.duration
    })

    return duration
  }

  calculateSessionDuration = (props, id) => {
    let duration = 0

    props.practice_sessions.map(session => {
      if (id === session.practice_type.id) { duration += session.duration }
    })

    return duration
  }

  combineSessions = (activity) => {
    let sessions = activity.practice_sessions ? activity.practice_sessions : []
    activity.logged_drills.forEach(ld => {
      sessions = [...sessions, ...ld.practice_sessions]
    })
    return { ...activity, practice_sessions: sessions }
  }

  renderTotalDurationCell = props => (
    <div
      className='number'
      style={{
        backgroundColor: '#2b3843',
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <div style={{ color: 'white' }}>
        {props.value}
      </div>
    </div>
  )

  renderPracticeTypeDurationCell = props => (
    <div
      className='number'
      style={{
        backgroundColor: '',
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <div style={{ color: '#2b3843' }}>
        {props.value}
      </div>
    </div>
  )

  renderActivityDateCell = props => (
    <div
      className='number'
      style={{
        backgroundColor: '',
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <div style={{ color: '#2b3843' }}>
        {moment(props.value).format('MM-DD-YYYY')}
      </div>
    </div>
  )

  renderTable = () => {
    const { t } = this.props
    const {
      // title,
      startDate,
      endDate,
      handleStartDateChanged,
      handleEndDateChanged,
    } = this.props
    const columns = [
      {
        Header: '',
        accessor: 'user',
        Cell: props => this.renderUserAvatarCell(props),
        sortable: false,
        fixed: true,
      },
      {
        Header: t('common.field.firstName'),
        accessor: 'user.first_name',
        fixed: true,
      },
      {
        Header: t('common.field.lastName'),
        accessor: 'user.last_name',
        fixed: true,
      },
      {
        Header: t('common.field.date'),
        accessor: 'activity_date',
        Cell: props => this.renderActivityDateCell(props),
      },
      {
        Header: t('reports.communityPracticeTable.totalDuration'),
        id: 'total_duration',
        accessor: this.calculateDuration,
        Cell: this.renderTotalDurationCell,
        style: { padding: 0 },
      },
      {
        Header: t('common.golf.putting'),
        id: 'putting',
        accessor: props => this.calculateSessionDuration(props, 1),
        Cell: this.renderPracticeTypeDurationCell,
      },
      {
        Header: t('common.golf.chipping'),
        id: 'chipping',
        accessor: props => this.calculateSessionDuration(props, 2),
        Cell: this.renderPracticeTypeDurationCell,
      },
      {
        Header: t('reports.communityPracticeTable.pitchShots'),
        id: 'pitch_shots',
        accessor: props => this.calculateSessionDuration(props, 3),
        Cell: this.renderPracticeTypeDurationCell,
      },
      {
        Header: t('reports.communityPracticeTable.wedges'),
        id: 'wedges',
        accessor: props => this.calculateSessionDuration(props, 4),
        Cell: this.renderPracticeTypeDurationCell,
      },
      {
        Header: t('common.golf.fullSwingIrons'),
        id: 'full_swing_irons',
        accessor: props => this.calculateSessionDuration(props, 5),
        Cell: this.renderPracticeTypeDurationCell,
      },
      {
        Header: t('common.golf.fullSwingWoods'),
        id: 'full_swing_woods',
        accessor: props => this.calculateSessionDuration(props, 6),
        Cell: this.renderPracticeTypeDurationCell,
      },
      {
        Header: t('common.golf.onCoursePlaySimulation'),
        id: 'play_simulation',
        accessor: props => this.calculateSessionDuration(props, 7),
        Cell: this.renderPracticeTypeDurationCell,
      },
      {
        Header: t('common.golf.bunkers'),
        id: 'bunkers',
        accessor: props => this.calculateSessionDuration(props, 8),
        Cell: this.renderPracticeTypeDurationCell,
      },
    ]

    return (
      <div className='container my-5 animated fadeIn'>
        <div className='row mb-5 d-flex align-items-center'>
          <div className='col-md-4'>
            <h2>{this.props.title}</h2>
          </div>
          <div className='col-md-4 d-flex align-items-center'>
            <div>
              <p className='m-0'>{t('common.field.startDate')}</p>
              <DatePicker
                name={'start-date'}
                id={'start-date'}
                startDate={startDate}
                endDate={endDate}
                type={'date'}
                className={'col-12 form-control'}
                onChange={handleStartDateChanged}
                placeholder={t('common.field.startDate')}
                selected={startDate}
                error={''}
              />
            </div>

            <div className='ml-2'>
              <p className='m-0'>{t('common.field.endDate')}</p>
              <DatePicker
                name={'end-date'}
                id={'end-date'}
                startDate={startDate}
                endDate={endDate}
                type={'date'}
                className={'col-12 form-control'}
                onChange={handleEndDateChanged}
                placeholder={t('common.field.endDate')}
                selected={endDate}
                error={''}
              />
            </div>
          </div>
          <div className='col-md-4'>
            <button
              className='btn btn-sm btn-block'
              onClick={() => this.props.goBack()}
            >
              <i
                className='fa fa-arrow-left text-white mr-1'
                aria-hidden='true'
              />{' '}
              {t('reports.common.viewAnotherReport')}
            </button>
          </div>
        </div>
        <div className='row'>
          <div className='col-12'>
            <ReactTableFixedColumns
              data={
                this.props.data[0] && !this.props.loader
                  ? this.props.data[0].practices
                  : []
              }
              columns={columns}
              defaultPageSize={10}
              loading={this.props.loader}
              loadingText={t('reports.common.loadingReport')}
              noDataText={
                this.props.data[0]
                  ? t('reports.communityPracticeTable.chooseDateRange')
                  : t('reports.common.noDataFound')
              }
            />
          </div>
        </div>
        <button onClick={this.createData} className='mt-3 btn btn-success'>
          {t('reports.common.exportAsCsv')}
        </button>
      </div>
    )
  }

  render() {
    const { t } = this.props
    return (
      <div>
        {this.renderTable()}
        <CSVExportModal
          headers={buildHeaders(t)}
          data={this.state.data}
          showModal={this.state.showModal}
          toggleModal={this.toggleModal}
          reportType={t('reports.communityPracticeTable.communityTrainingReport')}
          filename={'community-training-report.csv'}
        />
      </div>
    )
  }
}

export default withTranslation()(CommunityPracticeTable)
